import { useAuthStore } from '../../../../stores/auth';
import { isAgencyOperatedSite, operatorGroupLabel } from '../../../../lib/agencySiteLinkView';
import type { Site } from '../../../../lib/organizations';

/**
 * 현장 상세 「기본 정보」의 배치 그룹 항목(P4) — **대행 현장**(호출 조직 ≠ 소유 조직 · `isAgencyOperatedSite`)에서만 그린다.
 * 값은 응답 `operatorGroupId`(우리 조직의 배치 그룹)이고 이름은 현재 작업공간의 그룹 목록에서 해소한다. 소유 현장은
 * 종전처럼 아무것도 그리지 않는다. 읽기 전용 — 배치 그룹 변경 API는 P4 범위 밖이다.
 */
export function SiteOperatorGroupItem({
  site,
  dtClassName,
  ddClassName,
}: {
  site: Pick<Site, 'groupId' | 'operatorGroupId'>;
  dtClassName: string;
  ddClassName: string;
}) {
  const groups = useAuthStore((s) => s.currentMembership?.company?.groups) ?? [];
  if (!isAgencyOperatedSite(site)) return null;
  return (
    <div data-testid="site-operator-group">
      <dt className={dtClassName}>배치 그룹</dt>
      <dd className={ddClassName}>{operatorGroupLabel(site.operatorGroupId, groups)}</dd>
    </div>
  );
}
